export default props => (
    <button
        className={`
            h-[38px] border-none rounded-xl text-white text-center size-100
            ${props.btnSubmit ? 'bg-blue-connect text-[14px] !w-[186px]' : ''}
            ${props.btnProduct ? 'bg-blue-connect text-[14px] md:text-[17px] w-4/5' : ''}
            ${props.destaque ? '!bg-green-price text-[14px] md:text-[17px]' : ''}
            ${props.btnSejaParceiro ? 'text-[20px] h-[46px]' : ''}
        `}
        onClick={e => props.click?.(props.function)}
    >
        {props.labelBtn}
    </button>
);
